namespace Portico.Models {

    export class AuthenticationResponse {
        public status: PorticoAuthenticateStatus;
        public jwtToken: string;
        public session: SessionDetail;
        public success: boolean;
        public messages: string[];
        public sessionDetail: SessionDetail;
        public childSessionData: ChildSessionData[];

        constructor(obj?: any)
        {
            this.status = PorticoAuthenticateStatus.NotAuthenticated;
            this.jwtToken = null;
            this.success = null;
            this.messages = null;
            this.sessionDetail = new SessionDetail();
            this.childSessionData = null;
            
            if (obj) {
                this.jwtToken = obj.jwtToken || null;
                this.success = obj.sucsess || null;
                this.messages = (obj.messages || []).concat();
                this.status = obj.status || PorticoAuthenticateStatus.NotAuthenticated;
                this.sessionDetail = new SessionDetail(
                    {
                        'sessionId': obj.sessionId || null,
                        'expirationDate': obj.sessionId || null
                    });

                if (Array.isArray(obj.childSessionData)) {
                    this.childSessionData = [];
                    (obj.childSessionData as ChildSessionData[]).forEach((value: ChildSessionData) => {
                        this.childSessionData.push(new ChildSessionData(value));
                    });
                }
            }
        }
    }
}